import React, { useState, useEffect } from 'react';
import '../../assets/css/admin/dashboard.css';
// import VisitorStats from '../../components/elements/visitorStats';
import { adminApi } from '../../network/apis/admin';

const AdminDashboard = () => {
    const [stats, setStats] = useState({
        doctors: { total: 0, active: 0, pending: 0, newThisWeek: 0 },
        farms: { total: 0, newThisWeek: 0 },
        cases: { total: 0, active: 0, resolved: 0, pending: 0, newThisWeek: 0 },
        laboratories: { total: 0, verified: 0 },
        vendors: { total: 0, verified: 0 },
        orders: { totalThisMonth: 0, revenueThisMonth: 0 }
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchDashboardStats();
    }, []);

    const fetchDashboardStats = async () => {
        try {
            setLoading(true);
            setError(null);
            const response = await adminApi.getDashboardStats();
            if (response?.data) {
                setStats(response.data);
            }
        } catch (err) {
            console.error('Failed to fetch dashboard stats:', err);
            setError('Failed to load dashboard statistics');
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <main className="dashboard-content">
                <div className="loading-state">
                    <div className="spinner"></div>
                    <p>Loading dashboard...</p>
                </div>
            </main>
        );
    }

    if (error) {
        return (
            <main className="dashboard-content">
                <div className="error-state">
                    <p>{error}</p>
                    <button onClick={fetchDashboardStats} className="retry-btn">Retry</button>
                </div>
            </main>
        );
    }

    return (
        <main className="dashboard-content">
            <div className="stats-grid">
                <div className="stat-card">
                    <h3>Total Doctors</h3>
                    <div className="stat-value">{stats.doctors?.total || 0}</div>
                    <span className="stat-label">({stats.doctors?.active || 0} verified)</span>
                    {stats.doctors?.pending > 0 && (
                        <span className="stat-badge pending">{stats.doctors.pending} pending</span>
                    )}
                </div>
                <div className="stat-card">
                    <h3>Registered Farms</h3>
                    <div className="stat-value">{stats.farms?.total || 0}</div>
                    {stats.farms?.newThisWeek > 0 && (
                        <span className="stat-label">+{stats.farms.newThisWeek} this week</span>
                    )}
                </div>
                <div className="stat-card">
                    <h3>Active Cases</h3>
                    <div className="stat-value">{stats.cases?.active || 0}</div>
                    <span className="stat-label">({stats.cases?.resolved || 0} resolved)</span>
                </div>
                <div className="stat-card">
                    <h3>Laboratories</h3>
                    <div className="stat-value">{stats.laboratories?.total || 0}</div>
                    <span className="stat-label">({stats.laboratories?.verified || 0} verified)</span>
                </div>
            </div>

            {/* <div className="platform-overview">
                <h3>Real-time Platform Activity</h3>
                <VisitorStats variant="standard" />
            </div> */}
        </main>
    );
};

export default AdminDashboard;